import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=73b388eb&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=ts&"
export * from "./TaskItem.vue?vue&type=script&lang=ts&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=73b388eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b388eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b388eb')) {
      api.createRecord('73b388eb', component.options)
    } else {
      api.reload('73b388eb', component.options)
    }
    module.hot.accept("./TaskItem.vue?vue&type=template&id=73b388eb&scoped=true&", function () {
      api.rerender('73b388eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/TaskItem.vue"
export default component.exports